import { makeStyles } from '@material-ui/core';
import { scienceBlue } from '../../../abstracts/colours';
import { fonts, LARGE, XLARGE } from '../../../abstracts/constants';

export const useStyles = makeStyles({
  root: {
    height: XLARGE,
    padding: '0 4px',
    margin: 0,
    lineHeight: 'normal',
    boxShadow: 'none',
    textTransform: 'none',
    textDecoration: 'underline',
    textDecorationThickness: '1px', // only works on Firefox and Safari
    textAlign: 'right',
    fontSize: LARGE,
    fontFamily: fonts.sourceSansPro,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    color: scienceBlue,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
    '& .MuiButton-endIcon': {
      paddingTop: '5px',
    },
  },
});
